<template>
    <li class="preview-item">
        <span
            v-handle
            class="handle"
            v-if="showHandle"
        ></span>
        <!-- {{item}} -->
        <slot></slot>
    </li>
</template>

<script>
import { ElementMixin, HandleDirective } from 'vue-slicksort';

export default {
    mixins: [ElementMixin],
    props: ['item', 'showHandle'],
    directives: { handle: HandleDirective }
}
</script>



// WEBPACK FOOTER //
// PreviewItem.vue?efcaa230